export default {
  title: 'הצוות',
  members: {
    amir: {
      name: 'אמיר הסל',
      position: 'שותף',
      description: 'אמיר הקים את חטיבת ההשקעות בהראל ביטוח וניהל אותה במשך כ-18 שנים. במהלך כהונתו, אמיר השיג לתיק ההשקעות של הראל את התשואה הגבוהה ביותר במצטבר בין חברות הביטוח וקרנות הפנסיה. לאמיר תואר ראשון ושני בכלכלה ומנהל עסקים מאוניברסיטת תל אביב, שניהם בהצטיינות.',
    },
    omer: {
      name: 'עומר הרם',
      position: 'שותף מנהל',
      description: 'עומר בעל ניסיון של מעל 20 שנים בתחום הביטוח והפיננסים ובתפקידו האחרון היה סמנכ"ל בחברת כלל ביטוח ופיננסים. לעומר תואר ראשון, רישיון משווק השקעות מותלה, רישיון סוכן פנסיוני ואלמנטרי מטעם משרד האוצר.',
    },
    vadim: {
      name: 'ודים טריבל',
      position: 'שותף מנהל',
      description: 'ודים בעל ניסיון במגוון תפקידים בחברות ביטוח משנת 2004. ודים הקים את המרכז לתכנון פרישה בהראל ביטוח בשנת 2013 ובתפקידו האחרון שימש כסמנכ“ל. לודים תואר ראשון B.A בביטוח, תואר M.B.A מנהל עסקים, רישיון משווק השקעות מותלה, רישיון סוכן פנסיוני מטעם משרד האוצר.',
    },
    yael: {
      name: 'יעל ברורמן',
      position: 'מנהלת קשרי לקוחות',
      description: 'יעל בעלת ניסיון של מעל 10 שנים בתחום הביטוח והפיננסים. בתפקידה האחרון הייתה אחראית על השירות והתפעול לסוכני חברת הביטוח הפניקס. בעלת B.A במנהל עסקים, התמחות במימון.',
    },
    adi: {
      name: 'עדי שולטר',
      position: 'מנהלת קשרי לקוחות',
      description: 'עדי בעלת ניסיון של 4 שנים בתחום הביטוח והפיננסים. בתפקיד האחרון הייתה אחראית על השירות והתפעול לסוכני חברת הביטוח הפניקס. בעלת תואר MBA במנהל עסקים והתמחות במימון. B.A במנהל עסקים.',
    },
    max: {
      name: 'מקס טריבל',
      position: 'שותף מנהל',
      description: 'מקס, מומחה מנוסה בתחום המשרדים המשפחתיים עם למעלה מ-13 שנות ניסיון. כבעלים של Maxa Multi Family Office, הוא מנהל בקפדנות את הקצאת הנכסים עבור 23 משפחות, ומבטיח שהעושר שלהן יגדל וישגשג. עם המומחיות של מקס, העתיד הפיננסי שלכם בידיים בטוחות.',
    },
    shoshana: {
      name: 'שושנה שרון שחור',
      position: 'מתכננת פיננסית',
      description: 'שושנה בעלת ניסיון במגוון תפקידים בתחום הפיננסים. ב-15 שנה האחרונים עבדה במגוון תפקידים בהראל חברה לביטוח ובתפקידה האחרון שימשה כמתכננת פיננסית בכירה במרכז לתכנון פרישה בהראל. לשושנה תואר דו-מסלולי בניהול וכלכלה, ורישיון סוכן פנסיוני מטעם משרד האוצר.',
    },
    itzik: {
      name: 'איציק טיבי',
      position: 'מתכנן פיננסי',
      description: 'איציק בעל ניסיון של כ-18 שנים במגוון תפקידים בתחום הפיננסים. ב-15 שנה האחרונות עבד במגוון תפקידים בהראל חברה לביטוח ותפקידו האחרון היה מתכנן פיננסי בכיר. מתמחה בבניית אסטרטגיית השקעות ותכנון פיננסי למשפחות בעלות עושר פיננסי ויחידים בעלי ממון. איציק בעל תואר ראשון בכללה וניהול ובעל רישיון סוכן פנסיוני מטעם משרד האוצר.',
    },
    guy: {
      name: 'גיא אבן טוב',
      position: 'מתכנן פיננסי',
      description: 'גיא בעל ניסיון של 25 שנים בתחום הביטוח והפיננסים. שימש במגוון תפקידים בבתי ההשקעות ובחברות הביטוח בניהול השקעות וכמנהל חדר מסחר. ב-15 שנים האחרונות היה יועץ השקעות בבנק איגוד במחלקת הפלטינום, וייעץ ללקוחות הגדולים ביותר של הבנק. לגיא ניסיון רב וידע מעמיק בכל תחומי שוק ההון, בארץ ובחו״ל. לגיא תואר ראשון במימון מטעם המכללה למינהל, רישיון מנהל תיקים מטעם הרשות לניירות ערך מותלה, ובעל רישיון סוכן פנסיוני מטעם משרד האוצר.',
    },

  },
};
